module.exports = __webpack_public_path__ + "static/media/1.9dda7d0f.jpg";